"use strict";

exports.__esModule = true;
var _DashboardTagContext = require("./DashboardTagContext");
Object.keys(_DashboardTagContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardTagContext[key]) return;
  exports[key] = _DashboardTagContext[key];
});